export default __webpack_public_path__ + "static/media/louisliaologo.da1df30b.jpg";